import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { Estados, Funcoes } from '../services/funcoes';
import { Services } from '../services/servicos';
import { ClienteModel } from './cliente-model';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.css']
})

export class ClienteComponent implements OnInit {
  @ViewChild("txtCEP") txtCEP: ElementRef;
  @ViewChild("txtNumero") txtNumero: ElementRef;

  clientes: ClienteModel[];
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  loading: boolean = true;
  selectedCliente: ClienteModel;
  cliente: ClienteModel;
  clienteDialog: boolean;
  submitted: boolean;
  funcoes: Funcoes = new Funcoes();

  estados: Estados[];
  selecionarEstado: string;

  constructor(private service: Services, private messageService: MessageService, private confirmationService: ConfirmationService) {
    this.estados = this.funcoes.ListaEstados;
  }

  ngOnInit(): void {
    this.pesquisar();
    this.clienteDialog = false;
  }

  pesquisar() {
    this.loading = true;

    try {
      this.service.listarClientes()
        .subscribe(data => {
          if (data.Success) {
            this.clientes = data.Response;
            this.total = this.clientes.length;
            this.loading = false;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  //Funções

  abrirNovo() {
    this.cliente = {};
    this.cliente.cod_cliente = 0;
    this.submitted = false;
    this.clienteDialog = true;
  }

  Editar(cliente: ClienteModel) {
    this.cliente = { ...cliente };
    this.clienteDialog = true;
  }

  Deletar(cliente: ClienteModel) {
    try {

      this.confirmationService.confirm({
        message: 'Deseja remover ' + cliente.nome + '?',
        header: 'Confirmação',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          let resposta = this.service.removerDadosCliente(cliente);
          this.loading = true;
          resposta.subscribe(data => {
            if (data.Success) {
              this.messageService.add({ severity: 'success', summary: 'Informação', detail: data.Message });
              this.loading = false;
              this.cliente = {};
              this.pesquisar();
            }
          });
        }
      });


    } catch (error) {
      this.loading = false;
      alert(error)
    }
  }


  Salvar() {
    this.submitted = true;

    try {
      //CAMPOS OBRIGATÓRIOS
      var varNome = this.funcoes.getString(this.cliente.nome);
      var varNomeFatansia: string = this.funcoes.getString(this.cliente.nome_fantasia);
      var varCpfCnpj: string = this.funcoes.getString(this.cliente.cpf);
      var varCpfCnpj: string = this.funcoes.getString(this.cliente.cnpj);
      var varBairro: string = this.funcoes.getString(this.cliente.bairro);
      var varCidade: string = this.funcoes.getString(this.cliente.cidade);
      var varEndereco: string = this.funcoes.getString(this.cliente.endereco_cobranca);
      var varEstado: string = this.funcoes.getString(this.cliente.estado);
      var varNumero: string = this.funcoes.getString(this.cliente.numero);
      var varTelefone: string = this.funcoes.getString(this.cliente.telefone);

      if (varNome == "" || varNomeFatansia == "" ||
        varCpfCnpj == "" || varBairro == "" ||
        varCidade == "" || varEndereco == "" ||
        varEstado == "" || varNumero == "" ||
        varTelefone == "") {
        return;
      }
      //FIM CAMPOS OBRIGATÓRIOS

      let resposta = this.service.gravarDadosCliente(this.cliente);
      this.loading = true;
      resposta.subscribe(data => {
        if (data.Success) {
          this.messageService.add({ severity: 'success', summary: 'Informação', detail: data.Message });
          this.loading = false;
          this.clienteDialog = false;
          this.cliente = {};
          this.pesquisar();
        }
      });
    } catch (error) {
      this.loading = false;
      alert(error)
    }
  }

  fecharDialogo() {
    this.clienteDialog = false;
    this.submitted = false;
  }

  limparCampos() {
    this.cliente.nome = "";
    this.cliente.nome_fantasia = "";
    this.cliente.cpf = "";
    this.cliente.cnpj = "";
    this.cliente.email = "";
    this.cliente.endereco_cobranca = "";
    this.cliente.telefone = "";
    this.cliente.numero = "";
    this.cliente.estado = "";
    this.cliente.cidade = "";
    this.cliente.bairro = "";
    this.cliente.complemento = "";

  }
  //
  buscandoCep: boolean;
  buscaCep(event: any) {
    this.buscandoCep = true;

    try {
      this.service.buscaCep(event.target.value)
        .subscribe(data => {
          console.log(data);
          this.cliente.endereco_cobranca = data.logradouro;
          this.cliente.cidade = data.localidade;
          this.cliente.bairro = data.bairro;
          this.cliente.estado = data.uf;
          this.selecionarEstado = this.estados.find(c => c.nome = data.uf).nome;
          this.buscandoCep = false;
          this.txtNumero.nativeElement.focus();
        }
        );
    } catch (error) {
      this.buscandoCep = false;
    }
  }
}

